import { createModel } from '@rematch/core';
import api from '@/api';
import type { RootModel } from '.';

const UserModel = createModel<RootModel>()({
  state: {
    currentUser: {
      uid: 0,
      mobile: '',
      email: '',
      nickName: '',
      headImg: '',
      types: []
    }
  },

  reducers: {
    saveCurrentUser(_, action) {
      const { payload } = action;
      return {
        currentUser: payload || {}
      };
    }
  },

  effects: () => ({
    async fetchCurrent() {
      const { code, data } = await api.common.user.getUser();
      if (code !== 200) {
        return {};
      }
      const response = {
        ...data
      };
      this.saveCurrentUser({
        payload: response
      });
      return response;
    }
  })
});

export default UserModel;
